import { render, staticRenderFns } from "./QueueBoard.vue?vue&type=template&id=339919dc&scoped=true&"
import script from "./QueueBoard.vue?vue&type=script&lang=js&"
export * from "./QueueBoard.vue?vue&type=script&lang=js&"
import style0 from "./QueueBoard.vue?vue&type=style&index=0&id=339919dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339919dc",
  null
  
)

export default component.exports